// components/SectorBlock.jsx
export function BankingBlock({ company, data }) {
  const { casa, advancesGrowth, gnpa, nnpa, car } = data;
  const parts = [];

  if (casa != null) {
    parts.push(
      <>a CASA ratio of <strong>{casa}%</strong></>
    );
  }

  if (advancesGrowth != null) {
    parts.push(
      <>advances growth of <strong>{advancesGrowth}%</strong></>
    );
  }

  if (gnpa != null) {
    parts.push(
      <>Gross NPA of <strong>{gnpa}%</strong></>
    );
  }

  if (nnpa != null) {
    parts.push(
      <>Net NPA of <strong>{nnpa}%</strong></>
    );
  }

  if (car != null) {
    parts.push(
      <>a Capital Adequacy Ratio (CAR) of <strong>{car}%</strong></>
    );
  }

  if (!parts.length) return null;

  return (
    <p className="mb-5">
      Key banking indicators such as CASA ratio, advances growth, Gross NPA,
      Net NPA, and Capital Adequacy Ratio (CAR) provide insights into funding
      structure and asset quality.{" "}
      <strong>{company}</strong>{" "}
      {parts.map((part, index) => (
        <span key={index}>
          {index > 0 && ", "}
          {part}
        </span>
      ))}
      .
    </p>
  );
}

export function CorporateBlock({ company, data }) {
  if (!data) return null;

  const {
    operatingMargin,
    debtRatio,
    debtToEquity,
    roa,
    roe
  } = data;
  const parts = [];

  if (operatingMargin != null) {
    parts.push(
      <>an operating margin of <strong>{operatingMargin}%</strong></>
    );
  }

  if (debtRatio != null) {
    parts.push(
      <>a debt ratio of <strong>{debtRatio}</strong></>
    );
  }

  if (debtToEquity != null) {
    parts.push(
      <>a debt to equity ratio of <strong>{debtToEquity}</strong></>
    );
  }

  if (roa != null) {
    parts.push(
      <>a Return on Assets (ROA) of <strong>{roa}%</strong></>
    );
  }

  if (roe != null) {
    parts.push(
      <>a Return on Equity (ROE) of <strong>{roe}%</strong></>
    );
  }

  if (!parts.length) return null;

  return (
    <p className="mb-5">
      For non-banking companies, operational indicators such as operating margin,
      debt metrics, and efficiency ratios help in understanding business and
      financial structure across cycles.{" "}
      <strong>{company}</strong>{" "}
      {parts.map((part, index) => (
        <span key={index}>
          {index > 0 && ", "}
          {part}
        </span>
      ))}
      .
    </p>
  );
}


export function InsuranceBlock({ company, data }) {
  if (!data) return null;

  const {
    grossWrittenPremium,
    netPremium,
    premiumGrowth3Y,
    solvencyRatio,
    claimRatio,
    combinedRatio,
    investmentIncome
  } = data;

  const parts = [];

  if (grossWrittenPremium != null) {
    parts.push(
      <>gross written premium of <strong>Rs {grossWrittenPremium} Cr</strong></>
    );
  }

  if (netPremium != null) {
    parts.push(
      <>net premium of <strong>Rs {netPremium} Cr</strong></>
    );
  }

  if (premiumGrowth3Y != null) {
    parts.push(
      <>three-year premium growth of <strong>{premiumGrowth3Y}%</strong></>
    );
  }

  if (solvencyRatio != null) {
    parts.push(
      <>a solvency ratio of <strong>{solvencyRatio}%</strong></>
    );
  }

  if (claimRatio != null) {
    parts.push(
      <>a claim ratio of <strong>{claimRatio}%</strong></>
    );
  }

  if (combinedRatio != null) {
    parts.push(
      <>a combined ratio of <strong>{combinedRatio}%</strong></>
    );
  }

  if (investmentIncome != null) {
    parts.push(
      <>investment income of <strong>Rs {investmentIncome} Cr</strong></>
    );
  }

  if (!parts.length) return null;

  return (
    <p className="mb-5">
      For insurance companies, key operating indicators include premium growth,
      underwriting performance, solvency levels, and investment income, which
      together describe business scale and financial positioning.{" "}
      <strong>{company}</strong>{" "}
      {parts.map((part, index) => (
        <span key={index}>
          {index > 0 && ", "}
          {part}
        </span>
      ))}
      .
    </p>
  );
}

